import React, { useState, useEffect} from "react";
import { useLocation } from "react-router-dom";
import ImageCarousel from "../../ImageCarousel";

import "../../../styles/home_page/homePage.css";

// imported images
import Carousel1 from "../../photos/carousel/carousel-1.png";
import Carousel2 from "../../photos/carousel/carousel-2.png";
import Carousel3 from "../../photos/carousel/carousel-3.png";
import Carousel4 from "../../photos/carousel/carousel-4.png";

import HomePageForm from "./HomePageForm";
import HomePageInfoCards from "./HomePageInfoCards";



const HomePage = () => {

    const homePageImages = [
        Carousel1,
        Carousel2,
        Carousel3,
        Carousel4,
    ];

    const homePageTitle = [
        "Comfort Care 24/7 LLC",
        "Comfort Care 24/7 LLC",
        "Comfort Care 24/7 LLC",
        "Comfort Care 24/7 LLC"
    ]

    const [homePageIndex, setHomePageIndex] = useState(0);

    const whatIsComfortCare = "At Comfort Care 24/7, compassion is our guiding principle. We pride ourselves on providing compassionate care to our residents round the clock. Our dedicated team is committed to ensuring the comfort and well-being of each individual under our care, treating them with the kindness and respect they deserve. Whether you're considering independent living, assisted living or memory care for yourself or a loved one, we're here to offer support and guidance every step of the way. With several locations, we strive to create a warm and welcoming environment where residents feel valued and cared for."
    
    const location = useLocation();

    useEffect(() => {
        if (location.hash === "#contact") {
            const plansElement = document.getElementById("home-page-contact-id");
            if (plansElement) {
                plansElement.scrollIntoView({ behavior: "smooth"});
            }
        }
        
    });
    
    return (
        <div className="home-pg-container">
            <div className="home-pg-carousel-container">
                <ImageCarousel 
                        images={homePageImages} 
                        carouselTitles={homePageTitle}
                        carouselIndex={homePageIndex} 
                        setCarouselIndex={setHomePageIndex} 
                    />

            </div>
        
            <div className ="home-pg-content">
                <h2 className="home-pg-title">What Makes Comfort Care Living Different?</h2>
                
                <div className="content-color"/>

                <p className="home-pg-text">
                    {whatIsComfortCare}
                </p>

                <div className="content-color"/>
                <HomePageForm/>
                <div className="content-color"/>
                <HomePageInfoCards/>
            </div>
        </div>
    )
}

export default HomePage;